import { useEffect, useState } from 'react'
import {
  faFile,
  faFilePdf,
  faFilm,
  faMusic,
} from '@fortawesome/free-solid-svg-icons'

import type { MediaAsset } from '../../shared/api'
import { Icon, Spinner } from '../../shared/components'
import { currentTranslation } from '../../shared/i18n'

import { assetUrl } from './media.api'

export function MediaThumb({
  asset,
  size = '2x',
}: {
  asset: MediaAsset
  size?: '1x' | '2x'
}) {
  const [src, setSrc] = useState<string | null>(asset.url)

  useEffect(() => {
    let cancelled = false

    if (
      asset.mimeType.startsWith('image/') &&
      asset.status !== 'PROCESSING' &&
      asset.status !== 'UPLOADING'
    ) {
      void assetUrl(asset)
        .then((url) => !cancelled && setSrc(url))
        .catch(() => undefined)
    }

    return () => {
      cancelled = true
    }
  }, [asset])

  if (asset.status === 'PROCESSING' || asset.status === 'UPLOADING')
    return <Spinner label={currentTranslation().t.status.PROCESSING} />
  if (asset.mimeType.startsWith('image/') && src)
    return <img src={src} alt={asset.altText ?? ''} loading="lazy" />
  const icon =
    asset.mimeType === 'application/pdf'
      ? faFilePdf
      : asset.mimeType.startsWith('video/')
        ? faFilm
        : asset.mimeType.startsWith('audio/')
          ? faMusic
          : faFile

  return <Icon icon={icon} size={size} />
}
